import { createSlice } from "@reduxjs/toolkit";
import { CategoriesRepository, GeneralCategory, Loading } from "../domain";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type CategoriesState = {
  categories: GeneralCategory[];
  loading: Loading;
};

const initialState: CategoriesState = {
  categories: [],
  loading: "idle",
};

const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    categoriesLoading(state) {
      state.loading = "pending";
    },
    categoriesLoaded(state, { payload }) {
      state.categories = payload;
      state.loading = "succeeded";
    },
    categoriesFailed(state) {
      state.loading = "failed";
    },
  },
});

export default categoriesSlice.reducer;

const {
  categoriesFailed,
  categoriesLoaded,
  categoriesLoading,
} = categoriesSlice.actions;

export const loadCategories = (): AppThunk => async (dispatch) => {
  dispatch(categoriesLoading());
  const res = await ServiceLocater.get<CategoriesRepository>(
    Services.CategoriesRepository
  ).listCategories();
  res.fold(
    (_) => dispatch(categoriesFailed()),
    (r) => dispatch(categoriesLoaded(r))
  );
};
